import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { IconCacheService } from '@finxone-platform/shared/services';
import {
  iconSetApple,
  iconSetGoogle,
  iconSetMaterial,
  iconSetMaterialBold,
  iconSetMisc,
  iconSetPayabl,
  iconSetPrimeNg,
  IconType,
} from '@finxone-platform/shared/sys-config-types';

export const registerCustomIcons = function (
  matIconRegistry: MatIconRegistry,
  sanitizer: DomSanitizer,
  iconCacheService?: IconCacheService,
) {
  // Register the icon URL with MatIconRegistry
  function registerIcon(iconName: string, filePath: string) {
    matIconRegistry.addSvgIcon(iconName, sanitizer.bypassSecurityTrustResourceUrl(filePath));
  }

  // Collect all icon sets
  const allIcons: IconType[] = [];
  allIcons.push(...iconSetPrimeNg);
  allIcons.push(...iconSetMaterialBold);
  allIcons.push(...iconSetMaterial);
  allIcons.push(...iconSetMisc);
  allIcons.push(...iconSetPayabl);
  allIcons.push(...iconSetGoogle);
  allIcons.push(...iconSetApple);

  // Register icons with MatIconRegistry
  allIcons.forEach((icon) => registerIcon(icon.name, icon.url));

  // Initialize the URL mappings in IconCacheService for lazy loading
  if (iconCacheService) {
    iconCacheService.initializeIconUrls(allIcons);
  }
};

export function iconNameFromFileNameSvg(fileName: string) {
  return fileName.replace('.svg', '').toLowerCase();
}

export function registerProjectIconWithUrl(
  url: string,
  iconName: string,
  matIconRegistry: MatIconRegistry,
  domSanitizer: DomSanitizer,
) {
  fetch(url)
    .then((response) => response.text())
    .then((svg) => {
      matIconRegistry.addSvgIconLiteralInNamespace(
        'project',
        iconName,
        domSanitizer.bypassSecurityTrustHtml(svg),
      );
    })
    .catch((error) => {
      console.error(`Failed to fetch icon ${iconName}:`, error);
    });
}

export async function registerProjectIconWithUrlAsync(
  url: string,
  iconName: string,
  matIconRegistry: MatIconRegistry,
  domSanitizer: DomSanitizer,
): Promise<void> {
  try {
    const response = await fetch(url);
    const svg = await response.text();
    matIconRegistry.addSvgIconLiteralInNamespace(
      'project',
      iconName,
      domSanitizer.bypassSecurityTrustHtml(svg),
    );
  } catch (error) {
    console.error(`Failed to fetch icon ${iconName}:`, error);
  }
}
